import {
  Box,
  Card,
  Checkbox,
  Dialog,
  FormControl,
  InputLabel,
  MenuItem,
  Chip,
  Button as MUIButton,
  Select,
  Tooltip,
  Typography,
} from '@mui/material';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import dayjs from 'dayjs';
import { ReactElement, useState } from 'react';
import {
  BulkDeleteButton,
  CreateButton,
  Datagrid,
  EditButton,
  Filter,
  FunctionField,
  List,
  TextField,
  NumberField,
  TopToolbar,
  useListController,
  useTranslate,
  DeleteButton,
  SelectField,
  TextInput,
  SelectInput,
} from 'react-admin';
import { CustomBreadcrumbs } from '../../../../components/custom-breadcrumbs';
import { DashboardContent } from '../../../../layouts/dashboard';
import { Resources } from '../resource';
import { PermissionGuard } from 'src/routes/components/permission-guard';
import ErrorPage403 from 'src/pages/error/403';
import { PermissionButton } from 'src/routes/components/permission-button';
import CreateAgent from './Create';
import EditAgents from './Edit';

const AgentsList = () => {
  const [popup, setPopup] = useState<ReactElement>();
  const translate = useTranslate();

  const parseLevelNum = (name?: string): number | null => {
    const m = String(name ?? '')
      .trim()
      .match(/^Lv\s*(\d+)$/i);
    return m ? Number(m[1]) : null;
  };

  // Disable deletion for levels 1 to 5
  const cannotDelete = (row: any) => {
    console.log('row', row);
    
    const n = parseLevelNum(row?.name);
    return n !== null && n >= 1 && n <= 5;
  };

  return (
    <DashboardContent>
      <PermissionGuard resource="agents" action="read" fallback={<ErrorPage403 />}>
        <CustomBreadcrumbs
          heading={translate('resource.agentLevel')}
          links={[
            {
              name: translate('resource.agentLevel'),
              href: `/${Resources.agents}`,
            },
            { name: translate('resource.list') },
          ]}
          action={
            <PermissionGuard resource="agents" action="create" fallback={<></>}>
              <CreateButton
                variant="contained"
                size="medium"
                onClick={(e) => {
                  e.preventDefault();
                  setPopup(<CreateAgent onClose={() => setPopup(undefined)} />);
                }}
              />
            </PermissionGuard>
          }
        />

        <Card sx={{ mt: 3, pb: 2 }}>
          <List actions={false} empty={false} perPage={10} exporter={false}>
            <Box sx={{ overflow: 'auto' }}>
              <Datagrid
                rowClick={false}
                bulkActionButtons={
                  <PermissionButton resource="agents" action="delete">
                    <BulkDeleteButton />
                  </PermissionButton>
                }
                sx={{
                  '.RaBulkActionsToolbar-toolbar': {
                    position: 'relative !important',
                    transform: 'none !important',
                  },
                }}
              >
                <TextField source="id" label="module.agents.id" sortable={false} />
                <TextField source="name" label="module.agents.name" sortable={false} />
                <NumberField source="userCount" label="module.agents.userCount" sortable={false} />
                <TextField
                  source="directCommissionRate"
                  label="module.agents.directCommissionRate"
                  sortable={false}
                />
                <TextField
                  source="extendedCommissionRate"
                  label="module.agents.extendedCommissionRate"
                  sortable={false}
                />
                <TextField
                  source="indirectCommissionRate"
                  label="module.agents.indirectCommissionRate"
                  sortable={false}
                />
                {/* <TextField
                  source="makerFeeRate"
                  label="module.agents.makerFeeRate"
                  sortable={false}
                /> */}
                {/* <NumberField
                  source="memeFeeRebate"
                  label="module.agents.memeFeeRebate"
                  sortable={false}
                /> */}

                {/* <TextField
                  source="takerFeeRate"
                  label="module.agents.takerFeeRate"
                  sortable={false}
                /> */}
                {/* <NumberField
                  source="contractVolumeThreshold"
                  label="module.agents.contractVolumeThreshold"
                  sortable={false}
                />
                <NumberField
                  source="memeVolumeThreshold"
                  label="module.agents.memeVolumeThreshold"
                  sortable={false}
                /> */}
                <NumberField
                  source="totalCommission"
                  label="module.agents.totalCommission"
                  sortable={false}
                />
                <NumberField
                  source="totalVolumeUsd"
                  label="module.agents.totalVolumeUsd"
                  sortable={false}
                />

                <FunctionField
                  render={(record: any) => (
                    <Stack direction="row" spacing={2}>
                      <PermissionGuard resource="agents" action="update" fallback={<></>}>
                        <EditButton
                          onClick={(e) => {
                            e.preventDefault();
                            setPopup(
                              <EditAgents id={record.id} onClose={() => setPopup(undefined)} />
                            );
                          }}
                        />
                      </PermissionGuard>
                      {/* {!cannotDelete(record) && (
                        <PermissionGuard resource="agents" action="delete" fallback={<></>}>
                          <DeleteButton mutationMode="pessimistic" />
                        </PermissionGuard>
                      )} */}
                    </Stack>
                  )}
                />
              </Datagrid>
            </Box>
          </List>
        </Card>
        <Dialog open={Boolean(popup)} onClose={() => setPopup(undefined)} maxWidth="md" fullWidth>
          {popup}
        </Dialog>
      </PermissionGuard>
    </DashboardContent>
  );
};

export default AgentsList;
